<template>
  <v-container
    id="app-gift-credit"
    class="pa-1"
  >
    <screen
      :title="solde === 0 ? null : $t('field.loyalty.gift_solde')"
      :info="$amount(solde)"
      :titlesup="$t(solde === 0 ? 'field.loyalty.gift_reload' : 'field.loyalty.gift_use')"
      :infosup="$amount(total)"
      infoclass="green--text"
    />

    <!-- ***** SAISIE MONTANT ***** -->
    <keyboard
      v-model="total"
      @del="cancel"
      @cancel="cancel"
      @valid="valid"
    />
  </v-container>
</template>

<script>
import { Scan } from '@/modules/Scan'
import { $alert, $amount, createReference } from '@/modules/Utils'

export default {
  name: 'GiftCardView',

  props: {
    idBadge: { type: String, required: true },
    solde: { type: Number, default: 0 },
    date: { type: String, default: null }
  },

  data () {
    return {
      total: 0,
      reference: createReference()
    }
  },

  computed: {
    amount () { return this.$store.state.amount }
  },

  beforeMount () {
    this.$emit('title', this.$i18n.t(this.solde === 0 ? 'title.gift_credit' : 'title.gift_debit'))
  },

  methods: {
    $amount,
    // ********** KEYBOARD **********
    cancel () {
      this.$router.replace('/home')
    },
    valid () {
      if (this.total === 0) return
      Scan.launchDebit(this.idBadge, 'P', '', this.solde,
        () => {},
        (error) => {
          $alert(error)
        },
        false,
        null,
        this.total,
        false,
        this.reference
      )
    }
  }
}
</script>
